import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute } from '@jira/router-routes__project-settings-service-desk-automation-routes/src/projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { automationRedirect } from './ui/service-desk-automation/redirect/index.tsx';

/* Old urls.
 * Do not remove these redirects, ever.
 * Because customers will have bookmarks and saved links and we need them to keep working forever.
 */
export const projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry: Route =
	createEntry(
		projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute,

		() => ({
			layout: serviceProjectLayout,

			navigation: {
				menuId: MenuIdProjects,
				sidebarId: SidebarIdProjectSettings,
			},

			resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
			forPaint: [],
			// eslint-disable-next-line no-restricted-syntax
			component: automationRedirect('viewlog'),

			bifrost: {
				bifrostGroup: 'shell-only',
			},
		}),
	);
